module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_2-055f175fd7f6cd03c68b582bc9507df7.png";